<template>
  <div></div>
</template>

<script>
import IorderService from "../../services/iorder.service";
const _ = require("lodash");
export default {
  async mounted() {
    try {
      const result = await IorderService.url();
      console.log({ result });
      const url = _.get(result, "data.url");
      console.log({ url });
      if (url) {
        console.log("Redirecting to:", url);
        window.location = url;
        // window.open(url, "_blank", "noopener");
      } else {
        this.$router.push({
          name: "notfound404",
        });
      }
    } catch (error) {
      console.log(error);
      this.$router.push({
        name: "notfound404",
      });
    }
  },
};
</script>
